import { UseMutateFunction, useMutation } from "@tanstack/react-query";
import { AxiosResponse } from "axios";
import { logTags } from "configs/logging";
import { postIDOCR } from "services/ai/id-ocr";
import { IIDOCRResponse } from "types/id-ocr.d";
import { formatFormDataToObject } from "utils/formatter";
import { captureLogMessage, createExtras } from "utils/logging";

export const useIDOCR = (): {
  idOCRMutate: UseMutateFunction<
    AxiosResponse<unknown, unknown> | null,
    unknown,
    FormData,
    unknown
  >;
} => {
  const { mutate: idOCRMutate } = useMutation(
    (body: FormData) => postIDOCR(body),
    {
      onSuccess: (resp, body) => {
        const respData = resp?.data as IIDOCRResponse;
        if (!respData?.data) {
          const bodyParam = formatFormDataToObject(body);
          captureLogMessage(
            "OCR return null response",
            {
              ...logTags.request,
              requestURL: resp.config.url ?? "",
            },
            createExtras(bodyParam, resp)
          );
          throw new Error("cannot extract data");
        }
      },
    }
  );
  return { idOCRMutate };
};
